/* eslint-disable react/jsx-no-target-blank */
import InformacionAgente from 'components/MisDatosForm/InformacionAgente';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { SimpleWrapper } from '../componentes/contenedores';
import { DropDownFilter, TextInput } from 'components/InputsMex/inputs';
import { regex } from 'utils/validaciones';
import { useSelector } from 'react-redux';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { useFormContext } from 'react-hook-form';
import { emailRegex,inputNumericoEnteros } from '../componentes/validaciones';

const defaultDisclaimer = `
Al enviar mis datos autorizo que AIG Seguros México, S.A. de C.V.  me contacte vía telefónica a través de un asesor de seguros para seguimiento o apoyo a mi cotización. ¡Gracias por tu confianza! <br> <a href="https://www.aig.com.mx/content/dam/aig/lac/mexico/documents/forms/aig_aviso_de_privacidad_febrero_2020.pdf"
target="_blank" class="text-lightblue cpointer w-100">Revisa nuestro aviso de privacidad aquí</a>
`;

const MisDatosForm = ({
  disclaimer = defaultDisclaimer,
  inputs = [],
  catalogo = {},
  clavesAgente = [],     
}) => {
  
  const {
    dataUsuario: { userIsLoggedIn },
  } = useSelector((state) => state.datosUsuarios);

  const { watch } = useFormContext();

  const planSeleccionado = watch('datosCliente.planSeleccionado');

  useEffect(() => {

  }, [planSeleccionado]);    
  return (
    <div className="d-flex justify-content-center">
      <div className="col-lg-10 col-12">
        <div className="row w-100">
          <div className="col-12 col-md-6">
            <div className="container-accidentes">
             <h3 className="font-mex text-center" style={{ fontSize: '30px' }}>
                Perfil de negocio
              </h3>              
              {userIsLoggedIn && (
                <>
                <div className="form-group">
                    <SimpleContainer
                      label="Propiedades de la maquinaria"
                      name="datosGenerales.propiedadesMaquinaria"
                    >
                      <DropDownFilter
                        name="datosGenerales.propiedadesMaquinaria"
                        optionLabel="label"
                        optionValue="value"
                        options={
                          catalogo?.propiedadesMaquinaria?.map((item) => ({
                            ...item,
                            label: item.label,
                            value:item
                          }))
                        }                        
                        rules={{ required: 'Este campo es obligatorio' }}
                      />
                    </SimpleContainer>
                  </div>
                <div className="form-group">
                      <SimpleContainer label="Giro del negocio" name="datosGenerales.giroNegocio">
                      <TextInput
                        inputProps={{
                          name: 'datosGenerales.giroNegocio',
                          type: 'string',
                        }}
                        rules={{
                          required: regex.requiredMessage,
                          pattern: {
                            value: regex.nombre.value,
                            message: regex.nombre.mensaje,
                          },
                        }}
                      />
                    </SimpleContainer>
                  </div>
                
                  <div className="form-group">
                    <SimpleContainer
                      label="Moneda"
                      name="datosGenerales.moneda"
                    >
                      <DropDownFilter
                        name="datosGenerales.moneda"
                        optionLabel="label"
                        optionValue="value"
                        options={
                          catalogo?.moneda?.map((item) => ({
                            ...item,
                            label: item.label,
                            value:item
                          }))
                        }                                   
                        rules={{ required: 'Este campo es obligatorio' }}
                      />
                    </SimpleContainer>
                  </div>
                  
                  <div className="form-group">
                    <SimpleContainer
                      label="Ubicación de la maquinaria"
                      name="datosGenerales.ubicacionMaquinaria"
                    >
                      <DropDownFilter
                        name="datosGenerales.ubicacionMaquinaria"
                        optionLabel="label"
                        optionValue="value"
                        options={                          
                          catalogo?.estados?.map((item) => ({
                            ...item,
                            label: item.label,
                            value:item
                          }))
                        }                        
                        rules={{ required: 'Este campo es obligatorio' }}
                      />
                    </SimpleContainer>
                  </div>

                  <div className="form-group">
                    <SimpleContainer
                      label="Cuenta con siniestralidad en los últimos 3 años"
                      name="datosGenerales.siniestralidad"
                    >
                      <DropDownFilter
                        name="datosGenerales.siniestralidad"
                        optionLabel="label"
                        optionValue="value"
                        options={
                          catalogo?.siniestralidad?.map((item) => ({
                            ...item,
                            label: item.label,
                            value:item
                          }))
                        }    
                        filter={false}                    
                        rules={{ 
                          required: 'Este campo es obligatorio' ,
                          validate: {
                            checked: (item) => {                              
                              if (item.value =='no') {
                                return true;
                              }
                              if(catalogo?.msgErroresCatalogos?.msgSiniestralidad){
                                return catalogo?.msgErroresCatalogos?.msgSiniestralidad                                
                              }
                              else{return 'No se puede cotizar equipos que cuentan con sinistralidad'; }                             
                            },
                          },
                        }}
                      />
                    </SimpleContainer>
                  </div>
                 
                </>
              )}            
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="container-accidentes">
              <h3 className="font-mex text-center" style={{ fontSize: '30px' }}>
                Datos personales
              </h3>
            </div>

            {inputs.includes('usuNombre') && (
              <div className="form-group">
                <SimpleWrapper label="Nombre" name="datosCliente.usuNombre">
                  <TextInput
                    inputProps={{
                      name: 'datosCliente.usuNombre',
                      type: 'string',
                    }}
                    rules={{
                      required: regex.requiredMessage,
                      pattern: {
                        value: regex.nombre.value,
                        message: regex.nombre.mensaje,
                      },
                    }}
                  />
                </SimpleWrapper>
              </div>
            )}

            {inputs.includes('usuTelefono') && (
              <React.Fragment>
                <div className="form-group">
                  <SimpleWrapper label="Teléfono" name="datosCliente.usuTelefono">
                    <TextInput
                      inputProps={{
                        name: 'datosCliente.usuTelefono',
                        type: 'number',
                        onKeyDown: inputNumericoEnteros,
                      }}
                      extrasClasses="hide-arrows"
                      rules={{
                        required: regex.requiredMessage,
                        pattern: {
                          value: regex.telefono10.value,
                          message: regex.telefono10.mensaje,
                        },
                        minLength: {
                          value: 10,
                          message: 'Debe ingresar mínimo 10 números',
                        },
                        maxLength: {
                          value: 20,
                          message: 'Solo puede ingresar máximo 20 números',
                        },
                      }}
                    />
                  </SimpleWrapper>
                </div>
                
              </React.Fragment>
            )}
            {inputs.includes('usuRFC') && (
            <div className="form-group">
              <SimpleWrapper label="Rfc" name="datosCliente.usuRfc">
                <TextInput
                  inputProps={{name: 'datosCliente.usuRfc',}}
                  isUpper={true}
                  extrasClasses="hide-arrows"
                  rules={{
                    required: 'Este campo es obligatorio',
                    pattern: {
                        value: /^[A-Z]{3,4}[0-9]{6}[A-Z0-9]{3}$/,
                        message: "RFC incorrecto, el formato debe ser: AAAA######*** o AAA######***. Donde A es una letra, # es un número y los últimos 3 caracteres son alfanuméricos"
                    },
                    maxLength: {
                        value: 13,
                        message: "Ingrese hasta 13 caracteres",
                    },
                }}
                />
              </SimpleWrapper>
            </div>
          )}
          <div className="form-group container-accidentes">
                  <p
                    className="text-enviar-cotizacion"
                    style={{ fontSize: '20px', fontFamily: 'Futura-Medium' }}
                  >
                    Compártenos tu correo para enviarte tu cotización
                  </p>
                </div>

            {inputs.includes('usuCorreo') && (
              <div className="form-group">
                <SimpleWrapper label="Correo" name="datosCliente.usuCorreo">
                  <TextInput
                    inputProps={{
                      name: 'datosCliente.usuCorreo',
                    }}
                    rules={{
                      required: regex.requiredMessage,
                      validate: {
                        email: (value) => {
                          if (value === '') {
                            return true;
                          }
                          const valid = emailRegex.test(value);
                          if (!valid) {
                            return 'Ingrese un correo válido';
                          }
                          return true;
                        },
                      },
                    }}
                  />
                </SimpleWrapper>
              </div>
            )}

            {inputs.includes('disclaimerTerminos') && (
              <div className="container-accidentes">                
                <div
                  className="disclaimer-form-datos mt-3"
                  style={{ fontSize: '15px', fontFamily: 'Futura-Medium' }}
                  dangerouslySetInnerHTML={{
                    __html: disclaimer,
                  }}
                />
              </div>
            )}
            <InformacionAgente
              className="mt-3"
              border={false}
              options={clavesAgente}
              userIsLoggedIn={userIsLoggedIn}
            />
            <div className="d-flex justify-content-center mt-5">
              <Button type="submit" className="w-75">
                CONTINUAR
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MisDatosForm;
